import React, { useRef} from 'react';
import dxDataGrid from "devextreme/ui/data_grid";
import dxPivotGrid from "devextreme/ui/pivot_grid";
import dxChart from "devextreme/viz/chart";

export default class RefUtils {
    public static getInstanceByRef = (aref) => {
        let current = aref.current;
        if (current) {
            let instance = current.instance;
            if (instance) {
                return instance;
            }
        }
        return null;
    }
    public static dataGridInstance = (aref): dxDataGrid => {
        let dataGrid = aref.current;
        if (dataGrid) {
            let instance: dxDataGrid | null = dataGrid.instance;
            if (instance) {
                return instance;
            }
        }
        return null;
    }
    public static pivotInstance = (aref): dxPivotGrid => {
        let pivot = aref.current;
        if (pivot) {
            let instance: dxPivotGrid | null = pivot.instance;
            if (instance) {
                return instance;
            }
        }
        return null;
    }

    public static chartInstance = (aref): dxChart => {
        let chart = aref.current;
        if (chart) {
            //            return chart;
            let instance: dxChart | null = chart.instance;
            if (instance) {
                return instance;
            }
        }
        return null;
    }

}


